import React from 'react';

function Users() {
    return (
        <g>
            <path d="M0.5,21.9c0.3,0,0.5-0.2,0.5-0.5v-1.3c0-4.2,3.7-7.6,8.3-7.6s8.3,3.4,8.3,7.6v1.3c0,0.3,0.2,0.5,0.5,0.5
                c0.3,0,0.5-0.2,0.5-0.5v-1.3c0-3.9-2.9-7.3-6.8-8.3c1.6-0.9,2.6-2.6,2.6-4.5c0-2.9-2.3-5.2-5.2-5.2S4.2,4.4,4.2,7.3
                c0,1.9,1.1,3.6,2.6,4.5c-3.9,1-6.8,4.4-6.8,8.3v1.3C0,21.7,0.2,21.9,0.5,21.9z M5.2,7.3c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2
                s-1.9,4.2-4.2,4.2S5.2,9.6,5.2,7.3z"
            />
            <path d="M16.7,11.5c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5c3.5,0,6.3,2.6,6.3,5.8v1c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5
                v-1c0-3-2.1-5.6-5-6.5c1.1-0.7,1.9-2,1.9-3.5c0-2.3-1.9-4.2-4.2-4.2c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5
                c1.7,0,3.1,1.4,3.1,3.1S18.4,11.5,16.7,11.5z"
            />
        </g>
    );
}

export default Users;
